import React from "react";

import { FILE_UPLOAD_STATUS } from "constants/constants";
import { Icon } from "widgets";

import { UPLOAD_HISTORY_COPY } from "../../constants/uploadsContent";
import {
  formatUploadDate,
  getUploadHistoryDownloadLabel,
  getUploadHistoryRowTimestamp,
  getUploadHistoryStatusLabel,
  getUploadHistoryStatusSubtext,
  getUploadHistoryStatusVariant,
} from "../../utils/uploadsUtils";
import styles from "./FileUploadsHistory.module.scss";

const TABLE_COLUMNS = [
  UPLOAD_HISTORY_COPY.COLUMN_FILE_NAME,
  UPLOAD_HISTORY_COPY.COLUMN_UPLOADED_ON,
  UPLOAD_HISTORY_COPY.COLUMN_TOTAL_ROWS,
  UPLOAD_HISTORY_COPY.COLUMN_ERROR_ROWS,
  UPLOAD_HISTORY_COPY.COLUMN_STATUS,
  UPLOAD_HISTORY_COPY.COLUMN_ACTION,
];

const UploadHistoryTableRow = ({
  row,
  downloadingFileId,
  onDownloadProcessedFile,
}) => {
  const variant = getUploadHistoryStatusVariant(row);
  const errorRows = Number(row.result?.error_rows ?? 0);
  const statusSubtext = getUploadHistoryStatusSubtext(variant, errorRows);
  const isProcessed = row.status?.id === FILE_UPLOAD_STATUS.PROCESSED;
  const isDownloading = downloadingFileId === row.file_id;
  const emptyValue = UPLOAD_HISTORY_COPY.EMPTY_CELL;

  return (
    <tr>
      <td>
        <div className={styles.fileCell}>
          <Icon name="insertDriveFile" className={styles.csvIcon} />
          <span>{row.name || emptyValue}</span>
        </div>
      </td>
      <td>{formatUploadDate(getUploadHistoryRowTimestamp(row))}</td>
      <td>{row.result?.total_rows ?? emptyValue}</td>
      <td className={errorRows > 0 ? styles.errorCell : undefined}>
        {row.result?.error_rows ?? emptyValue}
      </td>
      <td>
        <div className={styles.statusCell}>
          <span className={styles.statusPill} data-variant={variant}>
            {getUploadHistoryStatusLabel(row, variant)}
          </span>
          {statusSubtext ? (
            <span className={styles.statusSubtext}>{statusSubtext}</span>
          ) : null}
        </div>
      </td>
      <td>
        <button
          type="button"
          className={styles.downloadBtn}
          onClick={() => onDownloadProcessedFile?.(row.file_id)}
          disabled={!isProcessed || isDownloading}
        >
          {getUploadHistoryDownloadLabel(isProcessed, isDownloading)}
        </button>
      </td>
    </tr>
  );
};

const UploadHistoryTable = ({
  rows,
  downloadingFileId,
  onDownloadProcessedFile,
}) => (
  <div className={styles.tableWrap}>
    <table className={styles.table}>
      <thead>
        <tr>
          {TABLE_COLUMNS.map((column) => (
            <th key={column}>{column}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <UploadHistoryTableRow
            key={row.file_id || row.name}
            row={row}
            downloadingFileId={downloadingFileId}
            onDownloadProcessedFile={onDownloadProcessedFile}
          />
        ))}
      </tbody>
    </table>
  </div>
);

export default UploadHistoryTable;
